module.exports = __webpack_public_path__ + "static/media/ordinary-day.fe7c0d7b.webp";